import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import AuthProvider from "./AuthProvider";
import AuthRoute from "./AuthRoute";
import OpenSession from "./OpenSession";
import Admin from "./Admin";
import Chat from "./Chat";

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/openSession" element={<OpenSession />} />

          <Route element={<AuthRoute />}>
            <Route path="/" element={<Chat />} />
          </Route>

          <Route element={<AuthRoute />}>
            <Route path="/admin" element={<Admin />} />
          </Route>

        </Routes>
      </AuthProvider>
    </Router>

  );
}

export default App;
